export const INIT_DELAY_MS = 150;
export const SUCCESS_DELAY_MS = 1500;

export const CREDENTIALS_ERROR_MSG =
  'Stripe credentials not configured. Please check your .env file.';
export const LOAD_ERROR_MSG = 'Failed to load payment form. Please refresh the page and try again.';
export const NOT_INITIALIZED_MSG = 'Payment form not initialized';
export const VERIFY_ERROR_MSG = 'Failed to verify payment method';

export const SUCCESS_TITLE = 'Payment Method Verified Successfully!';
export const LOADING_FORM_TEXT = 'Loading payment form...';
export const VERIFYING_TEXT = 'Verifying...';
export const VERIFYING_OVERLAY_TEXT = 'Verifying payment method...';

export const FREE_CONSULTATION_SUBTITLE = 'Your consultation is free';
export const STRIPE_SECURITY_NOTE = 'Securely stored with Stripe';

export const SUBTEXT_CONTENT =
  'No payment is taken at this step. Your card will not be charged at this time. This helps us hold your request with care and ensures a respectful experience for you and our practitioners.';

export const NO_PAYMENT_TEXT = (
  <>
    <strong>No payment is taken at this step.</strong>
    <br />
    We securely collect your card to hold your consultation request and support a respectful
    experience for you and our practitioners.
    <br />
    <br />
    Your card will{' '}
    <strong>only be charged after your first paid session</strong> is completed and processed by
    your practitioner.
  </>
);
